import type { PricingGridRow } from "@/screens/Pricing/components/tables/types"
import type { SurchargeFormValues, SurchargeItem } from "@/screens/Pricing/schema/surchargeFormSchema"

type SurchargeRowUpdate = Pick<
  PricingGridRow,
  | "surcharge1Price"
  | "surcharge1Description"
  | "surcharge2Price"
  | "surcharge2Description"
  | "surcharge3Price"
  | "surcharge3Description"
>

export const toSurchargeFormValues = (row: PricingGridRow): SurchargeFormValues => {
  const slots: SurchargeItem[] = [
    { price: row.surcharge1Price ?? null, description: row.surcharge1Description ?? "" },
    { price: row.surcharge2Price ?? null, description: row.surcharge2Description ?? "" },
    { price: row.surcharge3Price ?? null, description: row.surcharge3Description ?? "" },
  ]

  const surcharges = slots.filter(({ price, description }) => price !== null || description !== "")

  if (!surcharges.length) {
    return { surcharges: [{ price: null, description: "" }] }
  }

  return { surcharges }
}

export const toSurchargeRowUpdate = (values: SurchargeFormValues): SurchargeRowUpdate => {
  const [first, second, third] = values.surcharges

  return {
    surcharge1Price: first?.price ?? null,
    surcharge1Description: first?.description || null,
    surcharge2Price: second?.price ?? null,
    surcharge2Description: second?.description || null,
    surcharge3Price: third?.price ?? null,
    surcharge3Description: third?.description || null,
  }
}
